// 提携機能 BFF REST APIリクエスト関数

import type { CancelablePromise } from '@/init/swagger/core/CancelablePromise';
import { swaggerClient, swaggerClientForNonMember } from '@/init/swaggerClient';
import type {
  api_partnership_responseGetPartnerships,
  api_partnership_responseCreatePartnership,
  api_partnership_responseGetPartnershipByToken,
  api_partnership_responseRespondPartnership,
  api_partnership_responseCancelPartnership,
  api_partnership_responseTogglePartnershipPublic,
  api_partnership_responseDeletePartnership,
  api_partnership_responseGetPublicPartnerships,
  api_partnership_responseSearchPartnerCandidates,
  api_partnership_responseSendCarelogoodInvite,
  api_partnership_requestRespondPartnership,
  api_partnership_requestCreatePartnership,
} from '@/init/swagger';

/** 提携一覧取得 (POST /partnerships) */
export const getPartnerships = (
  applicantPortalOfficeId: number,
): CancelablePromise<api_partnership_responseGetPartnerships> =>
  swaggerClient.partnership.postPartnerships({
    body: { applicant_portal_office_id: applicantPortalOfficeId },
  });

/** 提携申請作成 (POST /partnership) */
export const createPartnership = (
  body: api_partnership_requestCreatePartnership,
): CancelablePromise<api_partnership_responseCreatePartnership> =>
  swaggerClient.partnership.postPartnership({ body });

/** トークンから申請情報取得 (POST /partnership/token) — 認証不要 */
export const getPartnershipByToken = (
  token: string,
): CancelablePromise<api_partnership_responseGetPartnershipByToken> =>
  swaggerClientForNonMember.partnership.postPartnershipToken({
    body: { approval_token: token },
  });

/** 承認/非承認 (POST /partnership/respond) */
export const respondPartnership = (
  body: api_partnership_requestRespondPartnership,
): CancelablePromise<api_partnership_responseRespondPartnership> =>
  swaggerClient.partnership.postPartnershipRespond({ body });

/** 申請取り消し (POST /partnership/cancel) */
export const cancelPartnership = (
  partnershipId: number,
): CancelablePromise<api_partnership_responseCancelPartnership> =>
  swaggerClient.partnership.postPartnershipCancel({
    body: { partnership_id: partnershipId },
  });

/** 公開/非公開切替 (POST /partnership/toggle_public) */
export const togglePartnershipPublic = (
  partnershipId: number,
  isPublic: boolean,
): CancelablePromise<api_partnership_responseTogglePartnershipPublic> =>
  swaggerClient.partnership.postPartnershipTogglePublic({
    body: { partnership_id: partnershipId, is_public: isPublic },
  });

/** 提携削除 (POST /partnership/delete) */
export const deletePartnership = (
  partnershipId: number,
): CancelablePromise<api_partnership_responseDeletePartnership> =>
  swaggerClient.partnership.postPartnershipDelete({
    body: { partnership_id: partnershipId },
  });

/** 公開地域連携先一覧 (POST /partnership/public) — 認証不要 */
export const getPublicPartnerships = (
  portalOfficeId: number,
): CancelablePromise<api_partnership_responseGetPublicPartnerships> =>
  swaggerClientForNonMember.partnership.postPartnershipPublic({
    body: { portal_office_id: portalOfficeId },
  });

/** 地域連携先候補検索 (POST /partnership/search_candidates) */
export const searchPartnerCandidates = (params: {
  keyword: string;
  organizationType: number;
  applicantPortalOfficeId: number;
}): CancelablePromise<api_partnership_responseSearchPartnerCandidates> =>
  swaggerClient.partnership.postPartnershipSearchCandidates({
    body: {
      keyword: params.keyword,
      organization_type: params.organizationType,
      applicant_portal_office_id: params.applicantPortalOfficeId,
    },
  });

/** ケアログっと招待メール送信 (POST /partnership/invite_carelogood) */
export const inviteCarelogood = (
  partnershipId: number,
): CancelablePromise<api_partnership_responseSendCarelogoodInvite> =>
  swaggerClient.partnership.postPartnershipInviteCarelogood({
    body: { partnership_id: partnershipId },
  });
